import { createSelector } from 'reselect';

const authentication = ({ authentication }) => authentication;

export const isAuthenticatedSelector = createSelector(
  authentication,
  ({ authenticated }) => authenticated
);
